/* Addie lander, page behaviour and cart.
 *
 * Ported from prototype/lander.js, with four deliberate differences. Each one is the
 * difference between a prototype and a page that takes money.
 *
 * 1. NO HARDCODED PRICES. The prototype carried `UNIT={p:29,w:35}`. Here every figure comes
 *    from #gbacLanderData, which Liquid renders from the live variants. This page must never
 *    become a fourth place the price ladder is restated: this store has already printed $70
 *    on six surfaces for a set that actually charged $59.50.
 *
 * 2. NO HARDCODED FINISH LIST. The prototype listed Gold, Silver and Rose Gold. Here the
 *    list is whatever Liquid emitted, and Liquid emits only finishes whose product is
 *    available. Rose gold is out of stock today, so it is simply absent, and it returns on
 *    its own the day it is back with nobody editing anything.
 *
 * 3. TOTALS SUM REAL PER-CHAIN PRICES rather than multiplying one unit price. All finishes
 *    happen to cost the same today. If one ever does not, multiplying would quietly
 *    overcharge or undercharge, and nothing on the page would look wrong.
 *
 * 4. THE CART IS REAL. It posts to /cart/add.js?gbac=1, which is the whitelist the fetch
 *    shim in layout/theme.liquid requires: a plain POST to /cart/add is swallowed and
 *    answered with a synthetic empty cart, which looks exactly like a broken add.
 *
 * The extender is gone entirely (Deven, 2026-09-21), and with it the defect where its
 * mid-page checkbox could land under the sticky bar and swallow a tap.
 */
(function () {
  'use strict';

  var dataEl = document.getElementById('gbacLanderData');
  if (!dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    // A malformed blob must not leave a half-live buy box that looks usable.
    console.error('[gbac-lander] could not parse #gbacLanderData; buy box disabled', e);
    return;
  }

  var finishes = (DATA.finishes || []).filter(function (f) { return f && f.available; });
  if (!finishes.length) {
    console.warn('[gbac-lander] no available finishes; nothing is purchasable on this page');
    return;
  }

  var RATE2 = Number(DATA.rates && DATA.rates.two) || 0;
  var RATE5 = Number(DATA.rates && DATA.rates.five) || 0;
  var FREE_SHIP = Number(DATA.freeShippingCents) || 5000;

  var tierEls = [].slice.call(document.querySelectorAll('#tiers .tier'));
  var pcards = [].slice.call(document.querySelectorAll('.pcard'));
  var COUNT = tierEls.map(function (t) { return Math.max(1, parseInt(t.dataset.chains, 10) || 1); });
  if (!COUNT.length) return;

  // Default to the second tier when there is one, matching the prototype's "most popular".
  var state = {
    tier: 0,
    picks: []
  };
  for (var i = 0; i < Math.max.apply(null, COUNT); i++) {
    state.picks.push(finishes[i % finishes.length].title);
  }

  function byTitle(t) {
    for (var i = 0; i < finishes.length; i++) if (finishes[i].title === t) return finishes[i];
    return finishes[0];
  }
  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.Shopify.money_format) {
      try { return window.Shopify.formatMoney(cents, window.Shopify.money_format); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }
  function rateFor(n) { return n >= 5 ? RATE5 : (n >= 2 ? RATE2 : 0); }

  /* Sum the ACTUAL chains selected, then apply the ladder. Not n * unit. */
  function quoteFor(n) {
    var now = 0, was = 0;
    for (var i = 0; i < n; i++) {
      var f = byTitle(state.picks[i]);
      now += Number(f.price) || 0;
      was += Number(f.compareAt) || Number(f.price) || 0;
    }
    var r = rateFor(n);
    return { n: n, now: Math.round(now * (100 - r) / 100), was: was };
  }
  function pill(now, was) {
    if (!was || was <= now) return '';
    return Math.round((1 - now / was) * 100) + '% off';
  }

  /* ---------- per-chain finish pickers ----------
     Built with DOM APIs rather than an HTML string. Finish titles come from the catalog,
     so they are not customer input, but they ARE free text a merchant types in admin and
     they would be interpolated straight into markup. Constructing the nodes means a title
     containing a quote or an angle bracket is text rather than markup, with no escaping
     helper to remember. The price fields below still use innerHTML, deliberately: their
     content is generated numerals and a literal <s> tag, with no external string in it. */
  function selectsInto(box, n, idPrefix) {
    box.textContent = '';
    for (var i = 0; i < n; i++) {
      var row = document.createElement('span');
      row.className = 'pickrow';

      var lbl = document.createElement('span');
      lbl.textContent = 'Chain ' + (i + 1);
      row.appendChild(lbl);

      var sel = document.createElement('select');
      sel.dataset.slot = String(i);
      sel.id = idPrefix + (i + 1);
      sel.setAttribute('aria-label', 'Chain ' + (i + 1) + ' finish');
      for (var j = 0; j < finishes.length; j++) {
        var opt = document.createElement('option');
        opt.textContent = finishes[j].title;
        if (finishes[j].title === state.picks[i]) opt.selected = true;
        sel.appendChild(opt);
      }
      row.appendChild(sel);
      box.appendChild(row);
    }
  }
  function bindSelect(s) {
    s.addEventListener('change', function () {
      state.picks[+s.dataset.slot] = s.value;
      syncSelects();
      if (+s.dataset.slot === 0) showFinish(s.value);
      render();
    });
  }
  function syncSelects() {
    document.querySelectorAll('#tiers .pickrows select, #midPicks select').forEach(function (s) {
      var v = state.picks[+s.dataset.slot];
      if (v && s.value !== v) s.value = v;
    });
  }
  function buildPickers() {
    document.querySelectorAll('#tiers .pickrows').forEach(function (box) {
      var n = parseInt(box.dataset.n, 10) || 1;
      if (n <= 1) { box.innerHTML = ''; return; }
      selectsInto(box, n, 'f' + n + '_');
      box.addEventListener('click', function (e) { e.stopPropagation(); });
    });
    remidPicks();
    document.querySelectorAll('#tiers .pickrows select').forEach(bindSelect);
  }
  function remidPicks() {
    var mid = document.getElementById('midPicks');
    if (!mid) return;
    var n = COUNT[state.tier];
    selectsInto(mid, n, 'm');
    mid.querySelectorAll('select').forEach(bindSelect);
    var lbl = document.getElementById('midPickLbl');
    if (lbl) lbl.textContent = n === 1 ? 'Your finish' : 'Your finishes';
  }

  /* ---------- swatches ---------- */
  var swatches = [].slice.call(document.querySelectorAll('.sw'));
  function showFinish(t) {
    swatches.forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.finish === t)); });
    var nameEl = document.getElementById('finishName');
    if (nameEl) nameEl.textContent = t;
    var sw = swatches.filter(function (x) { return x.dataset.finish === t; })[0];
    var img = document.getElementById('mainImg');
    if (sw && img && sw.dataset.img) {
      var u = sw.dataset.img.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
      img.srcset = [360, 540, 720, 1080].map(function (w) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w + ' ' + w + 'w'; }).join(', ');
      img.src = sw.dataset.img;
      img.alt = 'Addie Adjustable Twist Chain in ' + t.toLowerCase();
    }
  }

  function setText(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
  function setHTML(id, html) { var el = document.getElementById(id); if (el) el.innerHTML = html; }

  function render() {
    tierEls.forEach(function (t, i) {
      var q = quoteFor(COUNT[i]);
      var price = t.querySelector('[data-role="tierprice"]');
      if (price) price.innerHTML = money(q.now) + '<s>' + money(q.was) + '</s>';
      var p = t.querySelector('[data-role="pill"]');
      if (p) p.textContent = pill(q.now, q.was);
    });
    pcards.forEach(function (c, i) {
      var n = COUNT[i] || 1, q = quoteFor(n);
      var each = c.querySelector('.pc-each');
      if (each) each.innerHTML = '<s>' + money(Math.round(q.was / n)) + '</s> ' +
        money(Math.round(q.now / n)) + ' each';
      var tab = c.querySelector('[data-role="tab"]');
      if (tab) tab.textContent = pill(q.now, q.was);
    });

    var n = COUNT[state.tier], q = quoteFor(n);
    setText('hdNow', money(q.now));
    setText('hdWas', money(q.was));
    setText('hdPill', pill(q.now, q.was));
    // Persona round 2026-09-23: 7 of 8 read the top price as one chain's price while Two chains
    // was pre-selected. Say which option the price is for.
    setText('hdQty', 'for ' + n + ' chain' + (n > 1 ? 's' : ''));

    var label = 'Get my Adjustable Chain' + (n > 1 ? 's' : '') + ' · ' + money(q.now);
    setText('atcLabel', label);
    setText('atcLabel2', label);
    setHTML('stickyPrice', money(q.now) + '<s>' + money(q.was) + '</s>');
    setText('mpTotal', money(q.now));
    setText('mpWas', money(q.was));
    setText('mpShip', q.now >= FREE_SHIP
      ? 'You have unlocked FREE SHIPPING'
      : 'Add ' + money(FREE_SHIP - q.now) + ' more for FREE SHIPPING');
    setText('finishWho', n === 1 ? 'Finish' : 'Chain 1 finish');
  }

  function setTier(i) {
    state.tier = i;
    tierEls.forEach(function (x, j) {
      x.classList.toggle('on', j === i);
      var r = x.querySelector('input'); if (r) r.checked = (j === i);
    });
    pcards.forEach(function (c, j) { c.classList.toggle('on', j === i); });
    remidPicks();
    showFinish(state.picks[0]);
    // Deven, 2026-09-23: finishes are chosen in one place. With 2 or 5 chains the per-chain
    // dropdowns carry them, so the swatch row (which only sets Chain 1) steps aside.
    var multi = COUNT[i] > 1;
    document.querySelectorAll('.finish-lbl, .swatches').forEach(function (el) { el.hidden = multi; });
    render();
  }

  tierEls.forEach(function (t, i) { t.addEventListener('click', function () { setTier(i); }); });
  pcards.forEach(function (c, i) {
    function pick() { setTier(i); }
    c.addEventListener('click', pick);
    c.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
    });
  });
  swatches.forEach(function (b) {
    b.addEventListener('click', function () {
      state.picks[0] = b.dataset.finish;
      syncSelects();
      showFinish(b.dataset.finish);
      render();
      var tr = document.getElementById('track');
      if (tr) tr.scrollTo({ left: 0, behavior: 'smooth' });
    });
  });

  /* ---------- the real cart ---------- */
  var toast = document.getElementById('toast'), tt;
  function say(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('show'); }, 3200);
  }

  function lineItems() {
    /* Aggregate by variant so two chains of one finish post as quantity 2 rather than two
       separate lines, which is what the cart would merge them into anyway. */
    var byId = {}, order = [];
    for (var i = 0; i < COUNT[state.tier]; i++) {
      var f = byTitle(state.picks[i]);
      if (!f || !f.variantId) continue;
      if (!byId[f.variantId]) { byId[f.variantId] = 0; order.push(f.variantId); }
      byId[f.variantId] += 1;
    }
    return order.map(function (id) { return { id: Number(id), quantity: byId[id] }; });
  }

  var adding = false;
  function addToCart(btn) {
    if (adding) return;
    var items = lineItems();
    if (!items.length) { say('Sorry, that finish is not available right now.'); return; }
    adding = true;
    if (btn) btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js?gbac=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (body) { return { ok: res.ok, body: body }; });
    }).then(function (r) {
      if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'add failed');
      /* Verify the RESULT, not the response. The shim answers a swallowed add with a
         synthetic 200 carrying an empty items array, which is indistinguishable from a
         successful call if you only check res.ok. */
      var got = (r.body && r.body.items) || [];
      if (!got.length) throw new Error('the cart came back empty; the add did not take');
      var want = items.reduce(function (a, x) { return a + x.quantity; }, 0);
      var have = got.reduce(function (a, x) { return a + (x.quantity || 0); }, 0);
      if (have !== want) console.warn('[gbac-lander] asked for ' + want + ' items, cart reported ' + have);
      say('Added to your cart.');
      document.dispatchEvent(new CustomEvent('gbac:lander:added', { detail: { items: got } }));
      if (typeof window.monster_refresh === 'function') window.monster_refresh();
    }).catch(function (err) {
      console.error('[gbac-lander] add to cart failed', err);
      say('Sorry, that did not go through. Please try again.');
    }).then(function () {
      adding = false;
      if (btn) btn.removeAttribute('aria-busy');
    });
  }
  ['atc', 'atc2'].forEach(function (id) {
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', function () { addToCart(b); });
  });

  /* SHOP PAY (M16, decision 85a): the button had no handler. Same path as P1: add the selected tier through
     /cart/add.js?gbac=1, check the RESULT (the shim answers a swallowed add with an empty items array), then go
     to /checkout, where Shop Pay is offered. */
  var shopPay = document.querySelector('.shoppay');
  if (shopPay) shopPay.addEventListener('click', function () {
    if (adding) return;
    var items = lineItems();
    if (!items.length) { say('Sorry, that finish is not available right now.'); return; }
    adding = true; shopPay.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js?gbac=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (body) { return { ok: res.ok, body: body }; });
    }).then(function (r) {
      if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'add failed');
      if (!((r.body && r.body.items) || []).length) throw new Error('the cart came back empty; the add did not take');
      window.location.href = '/checkout';
    }).catch(function (err) {
      console.error('[gbac-lander] shop pay add failed', err);
      say('Sorry, that did not go through. Please try again.');
      adding = false; shopPay.removeAttribute('aria-busy');
    });
  });

  /* ---------- gallery, carousels, sticky ---------- */
  var track = document.getElementById('track');
  var thumbs = document.querySelectorAll('.thumbs button');
  if (track) {
    thumbs.forEach(function (b, i) {
      b.addEventListener('click', function () {
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      thumbs.forEach(function (b, j) { b.setAttribute('aria-current', String(j === i)); });
    }, { passive: true });
  }

  document.querySelectorAll('.carousel').forEach(function (car) {
    var tr = car.querySelector('.ctrack');
    var sl = car.querySelectorAll('.cslide');
    var dots = car.querySelectorAll('.cdot');
    var prev = car.querySelector('.prev'), next = car.querySelector('.next');
    if (!tr || !sl.length) return;
    function cur() {
      var x = tr.scrollLeft, b = 0, d = 1e9;
      sl.forEach(function (s, i) {
        var k = Math.abs(s.offsetLeft - tr.offsetLeft - x);
        if (k < d) { d = k; b = i; }
      });
      return b;
    }
    function go(i) {
      i = Math.max(0, Math.min(sl.length - 1, i));
      tr.scrollTo({ left: sl[i].offsetLeft - tr.offsetLeft, behavior: 'smooth' });
    }
    // Arrows and dots only when there is something to scroll to. On desktop every slide can
    // fit, and controls with nothing to do read as broken (Deven, 2026-09-23).
    var nav = car.querySelector('.cnav');
    function fits() { if (nav) nav.hidden = tr.scrollWidth <= tr.clientWidth + 4; }
    fits();
    window.addEventListener('resize', fits, { passive: true });
    window.addEventListener('load', fits);
    if (prev) prev.addEventListener('click', function () { go(cur() - 1); });
    if (next) next.addEventListener('click', function () { go(cur() + 1); });
    // Phone testimonials: one card shows at a time, so the track follows that card's height
    // instead of the tallest card's (board round 2: ~250px of blank under a short quote).
    var fitH = car.closest('.gbac-lander--testimonials') ? function () {
      if (window.innerWidth > 600) { tr.style.height = ''; return; }
      tr.style.height = (sl[cur()].offsetHeight + 12) + 'px';
    } : function () {};
    fitH();
    window.addEventListener('resize', fitH, { passive: true });
    window.addEventListener('load', fitH);
    tr.addEventListener('scroll', function () {
      fitH();
      var c = cur();
      dots.forEach(function (d, i) { d.setAttribute('aria-current', String(i === c)); });
    }, { passive: true });
  });

  var sticky = document.getElementById('sticky');
  var atcBtn = document.getElementById('atc');
  var queued = false;
  var stickyBtn = document.getElementById('stickyBtn');
  if (stickyBtn) stickyBtn.addEventListener('click', function () {
    var buy = document.getElementById('buy');
    if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  function syncSticky() {
    queued = false;
    if (!sticky || !atcBtn) return;
    /* Derived from position every frame rather than from an IntersectionObserver, which
       went stale after an instant jump on the prototype. */
    var show = atcBtn.getBoundingClientRect().bottom < 0;
    /* Board review 2026-09-23: stand down while the mid-page buy box or the footer is on
       screen, so the bar never sits on top of the thing it duplicates or the site's links. */
    var vh = window.innerHeight;
    var mid = document.querySelector('.midprice .inner');
    if (mid) { var m = mid.getBoundingClientRect(); if (m.top < vh - 80 && m.bottom > 80) show = false; }
    var foot = document.querySelector('footer.footer-sections, footer.site-footer-wrapper'); // not bare footer: testimonial cards use <footer>
    if (foot && foot.getBoundingClientRect().top < vh) show = false;
    sticky.classList.toggle('show', show);
    sticky.setAttribute('aria-hidden', String(!show));
  }
  function queueSticky() { if (queued) return; queued = true; requestAnimationFrame(syncSticky); }
  window.addEventListener('scroll', queueSticky, { passive: true });
  window.addEventListener('resize', queueSticky);

  buildPickers();
  showFinish(state.picks[0]);
  setTier(state.tier);
  syncSticky();
})();


/* Deven, 2026-09-23: ADJ15 does not stack with the pack pricing. The top bar's slide is removed
   in gbac-lander-pdp.liquid; the pre-footer marquee repeats the code, so hide those slides on
   this page too. ONE-SHOT sweeps only: a MutationObserver here fed the marquee's own re-cloning
   and the page never finished loading (rolled back 2026-09-23). Clones copy the inline style,
   so a hidden slide stays hidden when the ticker duplicates it. */
(function () {
  var RX = /ADJ15|15% OFF ADJUSTABLE CHAINS/i;
  function sweep() {
    document.querySelectorAll('[class*="section_announcement"] .announcement__slide, .shopify-section-group-group-pre-footer .announcement__slide').forEach(function (s) {
      if (s.style.display !== 'none' && RX.test(s.textContent || '')) s.style.display = 'none';
    });
  }
  document.addEventListener('DOMContentLoaded', sweep);
  window.addEventListener('load', function () { sweep(); setTimeout(sweep, 1500); });
})();
